enum TarsillaUserTypEnum {
    DIRECTOR = 'DIRECTOR',
    COORDINATOR = 'COORDINATOR',
    TECHNICIAN = 'TECHNICIAN',
    CARETAKER = 'CARETAKER',
}

export default TarsillaUserTypEnum;
